export default {
  payCodes: [],
  payCode: undefined
}
